<!-- Change only the identified area for routes -->

<template>
  <div v-if="useNavbar">
    <nav class="navbar navbar-expand-sm navbar-light bg-light border-bottom">
      <div class="container-fluid">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar">
          <div class="navbar-nav">
            <!-- Begin Edit Area - Add or update links -->
            <!-- use the named route pattern -->
            <RouterLink :to="{ name: 'Activity' }" class="nav-link me-3"
              >Survey</RouterLink
            >
            <RouterLink :to="{ name: 'Resources' }" class="nav-link me-3"
              >Resources</RouterLink
            >
            <RouterLink
              v-if="isAdmin"
              :to="{ name: 'Admin' }"
              class="nav-link me-3"
              >Admin</RouterLink
            >

            <!-- End Edit Area -->
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  computed: {
    ...mapGetters(["useNavbar", "isAdmin"])
  }
};
</script>
